import * as fe from "@runn/filter-engine"
import { useMemo } from "react"

import { AllowedProjectFilter } from "~/helpers/filter-engine"

import { selectProjectFilterSet } from "~/Planner/reducer2/selectFilteredProjects"
import { useAppSelector } from "~/hooks/redux"

const useProjectPlannerFilters = (
  viewFilters: AllowedProjectFilter | undefined,
) => {
  const filterSet = useAppSelector((state) =>
    selectProjectFilterSet(state.plannerV2),
  )

  return useMemo(() => {
    if (viewFilters) {
      return {
        ...filterSet,
        filters: fe.filters.simplify(
          fe.filters.and([filterSet.filters, viewFilters]),
        ),
      }
    }

    return filterSet
  }, [filterSet, viewFilters])
}

export default useProjectPlannerFilters
